var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"moor-button",style:({backgroundColor: _vm.bgcolor, borderColor: _vm.bgcolor, color: _vm.color}),attrs:{"disabled":_vm.buttonDisabled,"autofocus":_vm.autofocus},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f7b6116","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/button/moor-button.vue
// module id = 20
// module chunks = 0